import request from "@/utils/request";

export function sendSmsCode(query) {
  return request({
    url: "/notcheck/sendSms",
    method: "get",
    params: query,
  });
}

export function sendEmailCode(query) {
  return request({
    url: "/notcheck/sendEmail",
    method: "get",
    params: query,
  });
}

export function checkSmsExist(query) {
  return request({
    url: "/notcheck/sendSms/exist",
    method: "get",
    params: query,
  });
}

export function checkEmailExist(query) {
  return request({
    url: "/notcheck/sendEmail/exist",
    method: "get",
    params: query,
  });
}
